<template>
  <div id="coin_seller_payment_method">
    <van-nav-bar :title="$t('title.payment_method')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <!--   列表   -->
      <van-col span="24">
        <van-col span="24" class="coin_seller_payment_method_limit">
          {{ $t('column.add_up_currency_payment_channels', {number: limit})}}
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_payment_method_type" v-for="(item,i) in list" :key="i">
          <van-col span="14" offset="1" class="coin_seller_payment_method_type_country">
            <img :src="item.country_img"/> {{ item.country_name }} <span>{{ item.currency_name }}</span>
          </van-col>
          <van-col span="8" class="coin_seller_payment_method_type_country_edit">
            <van-icon name="delete" size="20px" color="#1A1A1A" @click="deleteBtn(item.currency_type_id)"/>
            <van-icon name="edit" size="20px" color="#1A1A1A" @click="jump_href(item.currency_type_id)"/>
          </van-col>
          <van-col span="22" offset="1">
            <van-col span="12" class="coin_seller_payment_method_type_payment_name">Payment Method</van-col>
            <van-col span="12" class="coin_seller_payment_method_type_payment_img">
              <img :src="t.img" v-for="(t,j) in item.payment_method_img" :key="j"/>
            </van-col>
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="coin_seller_payment_method_add" @click="CurrencyTypeShow = true" v-if="is_add">
          <van-icon name="plus" size="18px" color="#FF61F5"/> {{ $t('column.add_more') }}
        </van-col>
      </van-col>
      <van-popup v-model="CurrencyTypeShow" position="bottom" :style="{ height: '70%' }" round >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="jump_href(item.currency_type_id)">
            <van-col span="12" class="currency_type_list_name"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import {Dialog} from "vant";

export default {
  data() {
    return {
      CurrencyTypeShow: false,
      currency: {},
      currency_type: [],
      list: [],
      limit: 4,
      is_add: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    deleteBtn(currency_type_id){
      Dialog.confirm({
        title: this.$t('column.is_delete'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        // on confirm
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=delete_payment_method",{
          params:{uid: uid, token: token, currency_type_id: currency_type_id }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          Toast(res.data.error)
          this.getList()
        })
      }).catch(() => {
        // on cancel
      });
    },
    getList(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=get_bind_payment_method",{
        params:{uid: uid, token: token}
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status===1){
          this.list = res.data.data.list
          this.currency_type = res.data.data.currency_type
          this.is_add = this.list.length < this.limit
        }else{
          Toast(res.data.error)
        }
      })
    },
    jump_href(currency_type_id) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/payroll_seller_payment_method_select', query: { uid: uid, token: token, currency_type_id: currency_type_id } });
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1);
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/payroll_seller_payment_method.vue